import { RouteRecordRaw } from "vue-router";

const loginRouter: RouteRecordRaw[] = [
    {
        path: "/login",
        name: "Login",
        meta: { title: "登录" },
        component: () => import("@/views/pages/login/index.vue")
    },
    {
        path: "/login/findPassword",
        name: "FindPassword",
        meta: { title: "忘记密码" },
        component: () => import("@/views/pages/login/findPassword/index.vue")
    },
    {
        path: "/login/registerAccount",
        name: "RegisterAccount",
        meta: { title: "注册账号" },
        component: () => import("@/views/pages/login/registerAccount/index.vue")
    },
    {
        path: "/login/verifyIdentity",
        name: "VerifyIdentity",
        meta: { title: "身份验证" },
        component: () => import("@/views/pages/login/verifyIdentity/index.vue")
    }
];

export default loginRouter;
